import { FieldModel } from '@cibo/core'
import { Chip } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { useEqipRecommendations } from '../../queries'

export const fieldProgramStatusColumn = ({
  t,
  practiceName,
  overrides,
}: {
  t: TFunction
  practiceName?: string
  overrides?: Partial<Omit<GridColDef<FieldModel>, 'renderCell' | 'field'>>
}) =>
  ({
    field: 'programStatus',
    headerName: t('status', { ns: '@cibo/landmanager/FieldSelection' }),
    flex: 1,
    sortable: false,
    filterable: false,
    renderCell: (params: GridRenderCellParams<string, FieldModel>) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const { data } = useEqipRecommendations(params.id.toString())
      const currentPractice = data?.recommendations.find(
        practice => practice.practiceName === practiceName
      )
      const recommended = currentPractice?.tags.includes('Highly Recommended')
      const ineligible = currentPractice?.tags.includes('Ineligible')
      if (recommended) {
        return (
          <Chip
            label={t('recommended', { ns: '@cibo/landmanager/FieldsSelection' })}
            color="success"
            variant="filled"
          />
        )
      }
      if (ineligible) {
        return (
          <Chip
            label={t('ineligible', { ns: '@cibo/landmanager/FieldsSelection' })}
            color="error"
            variant="filled"
          />
        )
      }
    },
    ...overrides,
  } as GridColDef<FieldModel>)
